import React, { useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import {
  MarketShell, useMarketData, pivotSeries, LineChartBox,
} from './_shared';
import { ChartSection, formatMW, CHART_PALETTE } from '../charts/shared';

export default function MarketInterconnectors() {
  const [days, setDays] = useState(365);
  const { data, loading, error } = useMarketData('interconnectors', days);

  let body = null;
  if (data) {
    const flows = pivotSeries(data.flows || [], 'interconnector', 'avg_flow', {});
    flows.series = flows.series.map((s, i) => ({
      ...s, color: CHART_PALETTE[i % CHART_PALETTE.length],
    }));
    const constraints = data.constraints || [];

    body = (
      <>
        <ChartSection title="Average daily interconnector flow"
          subtitle="MWFLOW aggregated to daily mean — positive = nominal export direction (MW)">
          <LineChartBox x={flows.x} series={flows.series} yFormat={formatMW} />
        </ChartSection>

        <ChartSection title="Most-binding constraints"
          subtitle="Constraints with the most non-zero marginal-value intervals in the window">
          <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid', borderColor: 'divider' }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Constraint</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700 }}>Binding intervals</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700 }}>Avg marginal $</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700 }}>Max |marginal| $</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {constraints.map((c) => (
                  <TableRow key={c.constraint} hover>
                    <TableCell sx={{ fontFamily: 'Geist Mono, monospace', fontSize: '0.8rem' }}>
                      {c.constraint}
                    </TableCell>
                    <TableCell align="right">{c.bind_intervals.toLocaleString('en-AU')}</TableCell>
                    <TableCell align="right">{c.avg_marginal == null ? '—' : c.avg_marginal.toFixed(1)}</TableCell>
                    <TableCell align="right">{c.max_marginal == null ? '—' : c.max_marginal.toLocaleString('en-AU')}</TableCell>
                  </TableRow>
                ))}
                {constraints.length === 0 && (
                  <TableRow><TableCell colSpan={4} align="center" sx={{ color: 'text.secondary' }}>
                    No binding constraints in window
                  </TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </ChartSection>
      </>
    );
  }

  return (
    <MarketShell
      title="Interconnectors & Constraints"
      subtitle="Inter-regional flows and network binding constraints — real AEMO actuals"
      days={days} setDays={setDays} loading={loading} error={error}
    >
      {body}
    </MarketShell>
  );
}
